import api from "@/lib/api";
import { FadeUp, SectionHead } from "@/components/Reveal";
import { useQuery } from "@tanstack/react-query";
import { useLang } from "@/lib/i18n";

export default function Team() {
  const { lang } = useLang();
  const zh = lang === "zh";
  const { data: team = [] } = useQuery({
    queryKey: ["team"],
    queryFn: () => api.get("/team").then((r) => r.data),
    staleTime: 60_000,
  });

  return (
    <section id="team" data-testid="team" className="py-24 md:py-32 bg-[#0a0a0a]">
      <div className="max-w-[1800px] mx-auto px-4 md:px-8">
        <SectionHead no="04" en="THE DREAM MAKERS" zh="幕后团队" />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {team.map((m, i) => (
            <FadeUp key={m.id || i} delay={i * 0.12} className="group border border-white/10 hover:border-[#ffde00] transition-colors duration-300" data-testid={`team-card-${i}`}>
              <div className="relative overflow-hidden h-[380px] md:h-[460px]">
                {m.image && (
                  <img
                    src={m.image}
                    alt={m.name}
                    loading="lazy"
                    className="w-full h-full object-cover grayscale group-hover:grayscale-0 group-hover:scale-105 transition duration-700 ease-out"
                  />
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-transparent to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8">
                  <h3 className="font-display text-3xl md:text-4xl uppercase text-[#f5f5f5]">{m.name}</h3>
                  <p className="font-mono2 text-[11px] text-[#ffde00] tracking-[0.2em] mt-2 uppercase">{m.role_en}</p>
                  <p className="font-zh text-sm text-[#a1a1aa] mt-1">{m.role_zh}</p>
                </div>
              </div>
              <p className="font-zh text-sm md:text-base text-[#a1a1aa] leading-relaxed p-6 md:p-8 group-hover:text-[#f5f5f5] transition-colors duration-300">
                {zh ? m.bio : m.bio_en || m.bio}
              </p>
            </FadeUp>
          ))}
        </div>
        <FadeUp className="mt-10 border border-[#ffde00]/40 bg-[#ffde00]/5 px-6 md:px-10 py-6 flex flex-col md:flex-row md:items-center gap-4 md:gap-10">
          <span className="font-display text-2xl md:text-3xl uppercase text-[#ffde00] whitespace-nowrap">FIRST AIDERS</span>
          <p className="font-zh text-sm md:text-base text-[#a1a1aa] leading-relaxed">
            {zh
              ? "DFE 是马来西亚首家配备认证急救员（Certified Occupational First Aider）的娱乐公司 — 现场安全，与舞台同样重要。"
              : "DFE is the first entertainment company in Malaysia with certified occupational first aiders on the team — on-ground safety matters as much as the show."}
          </p>
        </FadeUp>
      </div>
    </section>
  );
}
